"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AisonApplicationGenerator = exports.AisonApplicationFieldResult = void 0;
const startCase_1 = __importDefault(require("lodash/startCase"));
const snakeCase_1 = __importDefault(require("lodash/snakeCase"));
const isFQDN_1 = __importDefault(require("validator/lib/isFQDN"));
const isURL_1 = __importDefault(require("validator/lib/isURL"));
const isHexColor_1 = __importDefault(require("validator/lib/isHexColor"));
const isRFC3339_1 = __importDefault(require("validator/lib/isRFC3339"));
const isISO8601_1 = __importDefault(require("validator/lib/isISO8601"));
const isNumeric_1 = __importDefault(require("validator/lib/isNumeric"));
const isEmail_1 = __importDefault(require("validator/lib/isEmail"));
const isJSON_1 = __importDefault(require("validator/lib/isJSON"));
const isLatLong_1 = __importDefault(require("validator/lib/isLatLong"));
const index_1 = require("./index");
const utils_1 = require("../utils");
const aison_field_data_1 = require("../utils/aison-field-data");
class AisonApplicationFieldResult {
    constructor(key) {
        this.types = {};
        this.aisonTypes = {};
        this.empty = 0;
        this.nonEmpty = 0;
        this.sourceKey = key;
        const parts = key.split('.');
        let baseName = parts[parts.length - 1].toLocaleLowerCase();
        if (baseName == 'id') {
            baseName = 'old_id';
        }
        this.name = (0, startCase_1.default)(baseName);
        this.targetKey = (0, snakeCase_1.default)(this.name);
    }
    check(value) {
        this.checkType(value);
    }
    checkType(value) {
        const type = typeof value;
        if (type === 'object') {
            this.checkObject(value);
        }
        else if (type === 'string') {
            this.checkString(value);
        }
        else {
            this.addType(type);
            switch (type) {
                case 'number':
                    this.addAisonType('Number');
                    break;
                case 'boolean':
                    this.addAisonType('Toggle');
                    break;
            }
        }
        if (value === null || value === undefined) {
            this.empty++;
        }
        else {
            this.nonEmpty++;
        }
    }
    checkObject(value) {
        if (value instanceof Date) {
            this.addType('date');
            this.addAisonType('DateTime');
        }
    }
    checkString(value) {
        let type = 'string';
        let aisonType = 'Text';
        if ((0, isEmail_1.default)(value)) {
            aisonType = 'EMail';
        }
        else if ((0, isURL_1.default)(value) || (0, isFQDN_1.default)(value)) {
            aisonType = 'URL';
        }
        else if ((0, isISO8601_1.default)(value) || (0, isRFC3339_1.default)(value)) {
            type = 'date';
            aisonType = 'DateTime';
        }
        else if ((0, isNumeric_1.default)(value)) {
            type = 'number';
            aisonType = 'Number';
        }
        else if ((0, isHexColor_1.default)(value)) {
            aisonType = 'Colour';
        }
        else if ((0, isJSON_1.default)(value)) {
            aisonType = 'Data';
        }
        else if ((0, isLatLong_1.default)(value)) {
            aisonType = 'Location';
        }
        this.addType(type);
        this.addAisonType(aisonType);
    }
    addType(type) {
        if (!this.types[type]) {
            this.types[type] = 0;
        }
        this.types[type]++;
    }
    addAisonType(type) {
        if (!this.aisonTypes[type]) {
            this.aisonTypes[type] = 0;
        }
        this.aisonTypes[type]++;
    }
}
exports.AisonApplicationFieldResult = AisonApplicationFieldResult;
class AisonApplicationGenerator extends index_1.Generator {
    static get FIELD_TYPES() {
        return aison_field_data_1.AISON_FIELD_TYPES;
    }
    generate(data) {
        const result = {
            name: '',
        };
        const fields = {};
        for (const item of data) {
            const flat = (0, utils_1.flattenKeys)(item);
            for (const key of Object.keys(flat)) {
                const value = flat[key];
                if (!fields[key]) {
                    fields[key] = new AisonApplicationFieldResult(key);
                }
                fields[key].check(value);
            }
        }
        return Object.values(fields);
    }
    createFieldMetadata() {
        return {
            type: new Set(),
            optional: false,
            empty: true,
        };
    }
}
exports.AisonApplicationGenerator = AisonApplicationGenerator;
//# sourceMappingURL=aison-application-generator.js.map